<template>
    <ThePage>
        <div class="mb-4 d-flex flex-column flex-md-row align-items-md-center justify-content-md-between">
            <div class="mb-2 mb-md-0">
                <select-date-range v-model="range" class="mr-4 d-none d-lg-inline-block" />
                <date-range-picker v-model="range" class="w-100" :shortcuts="false" :clearable="false" />
            </div>

            <div v-if="transactions.length > 0" class="ml-0 ml-md-5">
                <small>Выгрузить:</small>
                <button type="button" class="btn btn-outline-primary ml-2" @click.prevent="getFile('csv')">CSV</button>
                <button type="button" class="btn btn-outline-primary ml-2" @click.prevent="getFile('xlsx')"><i class="tlm-icon-excel mr-2" /> Excel</button>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th v-sort:created_at>Дата</th>
                            <th v-sort:company_id class="w-25">Компания</th>
                            <th v-sort:amount>Сумма</th>
                            <th>Комментарий</th>
                            <th v-sort:user_id class="text-nowrap">Кто скорректировал</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="tx in transactions" :key="tx.id">
                            <td>{{ tx.created_at | date }}</td>
                            <td>
                                <router-link :to="{ name: 'admin.company', params: { id: tx.company.id }}">{{ tx.company.name || 'Компания без названия' }}</router-link>
                            </td>
                            <td class="text-nowrap">
                                <strong :class="[ tx.type === 1 ? 'text-success' : 'text-danger' ]">{{ tx.amount | money }} {{ tx.company.bill_currency | currencySymbol }}</strong>
                            </td>
                            <td>{{ tx.comment }}</td>
                            <td>
                                <span v-if="tx.user" class="text-nowrap">
                                    {{ tx.user.name }}
                                </span>

                                <template v-else>
                                    <span class="text-muted">Пользователь не указан</span>
                                </template>
                            </td>
                        </tr>
                    </tbody>

                    <tfoot v-if="transactions.length === 0" class="no-one">
                        <tr>
                            <td colspan="42">Ни одной транзакции не найдено.</td>
                        </tr>
                    </tfoot>
                </table>

                <div class="d-flex flex-row flex-wrap justify-content-between align-items-center">
                    <span />
                    <pagination v-show="meta && meta.last_page > 1" :meta="meta" class="pagination" @input="applyFilter({ page: $event })" />
                </div>
            </div>
        </div>
    </ThePage>
</template>

<script>
import axios from 'axios'
import FileSaver from 'file-saver'

import store from '@/store'
import adminStoreModule from '@/store/modules/admin'

import ThePage from '@/components/ThePage'
import Pagination from '@/components/Pagination'
import DateRangePicker from '@/components/DateRangePicker'
import SelectDateRange from '@/components/SelectDateRange'

import DateCacheService, { oneWeekAgoRange } from '@/services/DateCacheService'

if (!store.state['admin']) {
    store.registerModule('admin', adminStoreModule)
}

function resolveDefaultRange() {
    return DateCacheService.getFormatted('admin-transactions', oneWeekAgoRange)
}

const beforeRoute = async (to, from, next) => {
    if (!to.query.since || !to.query.until) {
        return next({ name: to.name, query: resolveDefaultRange() })
    }

    await Promise.all([
        store.dispatch('admin/transactions/fetchAll', to.query)
    ])

    next()
}

export default {
    components: {
        ThePage,
        Pagination,
        DateRangePicker,
        SelectDateRange
    },

    props: {
        filter: {
            type: Object,
            default: _ => ({ })
        }
    },

    computed: {
        transactions() {
            return store.state.admin.transactions.data || []
        },

        meta() {
            return store.state.admin.transactions.meta || {}
        },

        range: {
            set({ alias, ...range }) {
                alias
                    ? DateCacheService.setAlias('admin-transactions', alias)
                    : DateCacheService.set('admin-transactions', range)

                this.applyFilter({ ...range, page: 1 })
            },

            get() {
                return this.filter
            }
        }
    },

    methods: {
        async getFile(format) {
            let response = await axios.get('api/admin/transactions', {
                responseType: 'blob',
                params: { export: format, ...this.filter }
            })

            if (!response.data.size) {
                return
            }

            let blob = new Blob([response.data], { type: format === 'xlsx' ? 'application/vnd.ms-excel' : 'text/csv' })
            FileSaver.saveAs(blob, `Корректировки ${this.filter.since} - ${this.filter.until}.${format}`)
        }
    },

    beforeRouteEnter: beforeRoute,
    beforeRouteUpdate: beforeRoute
}
</script>
